import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-surge-price-modal",
  templateUrl: "./surge-price-modal.component.html",
  styleUrl: "./surge-price-modal.component.scss",
  standalone: false
})
export class SurgePriceModalComponent {
  surgePriceModalRef!: NgbModalRef;
  surgeUnit: any;
  modalConfig: any = { size: "md", centered: true, backdrop: "static" };

  @ViewChild("surgePriceModal", { static: true }) surgePriceModal!: NgbModal;

  @Output() surgePriceEvent = new EventEmitter();

  constructor(public helper: Helper, private modalService: NgbModal) {}

  /**
   * Opens the surge price modal with the provided surge unit.
   * Configures the modal with predefined settings and handles the modal result.
   *
   * @param surgeUnit The surge unit to be used in the modal.
   */
  openModal(surgeUnit: any): void {
    this.surgeUnit = surgeUnit;
    this.surgePriceModalRef = this.modalService.open(this.surgePriceModal, this.modalConfig);
    this.surgePriceModalRef.result.then(
      () => this.closeModal(),
      () => this.closeModal()
    );
  }

  /**
   * Handles the submission of the surge price modal.
   * Emits an event indicating whether the surge price is confirmed and closes the modal.
   *
   * @param isSurgeConfirm A boolean indicating if the surge price is confirmed.
   */
  onSubmit(isSurgeConfirm: boolean): void {
    this.surgePriceEvent.emit(isSurgeConfirm);
    this.closeModal();
  }

  /**
   * Closes the surge price modal and resets the surge unit after a delay.
   */
  closeModal(): void {
    this.surgePriceModalRef.close();
    setTimeout(() => {
      this.surgeUnit = null;
    }, 600);
  }
}
